import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  onSuccess: Function;
}

export function useAtualizarIndicadores(props: Props) {
  const fetchData = async () => {
    const ATUALIZAR_INDICADORES = `${leadsWebEnviroment}/commom/leads/atualiza-indicadores/v1`;
    const response = await instance.get(ATUALIZAR_INDICADORES);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: ["atualizar-indicadores"],
    refetchOnWindowFocus: false,
    enabled: false,
    cacheTime: 0,
    onSuccess: () => {
      toast.success("Indicadores atualizados com sucesso");
      props.onSuccess();
    },
    onError: (error: any) => {
      toast?.error(
        `Erro ao atualizar indicadores. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
